module.exports = __webpack_public_path__ + "img/partner2.13e5e97a.png";